import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import SupportTicketsPage from '../components/SupportTicketsPage';
import ResponsiveLayout from '../components/ResponsiveLayout';
import { principalNavItems } from '../config/principalNav';
import { HelpCircle } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export default function PrincipalSupport() {
  const navigate = useNavigate();
  const [principalName, setPrincipalName] = useState('Principal');

  useEffect(() => {
    const token = localStorage.getItem('principal_token');
    if (!token) { navigate('/principal/login'); return; }
    axios.get(`${BACKEND_URL}/api/principal/dashboard?token=${token}`)
      .then(r => setPrincipalName(r.data?.principal?.name || 'Principal'))
      .catch(() => {});
  }, [navigate]);

  const handleLogout = () => {
    localStorage.removeItem('principal_token');
    navigate('/principal/login');
  };

  return (
    <ResponsiveLayout
      navItems={principalNavItems}
      userRole="principal"
      userName={principalName}
      onLogout={handleLogout}
    >
      <div className="font-body">
        {/* Header */}
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mb-5 sm:mb-6">
          <div>
            <h1 className="text-xl sm:text-2xl md:text-3xl font-heading font-bold text-sanjaya-navy flex items-center gap-2 sm:gap-3">
              <HelpCircle className="w-6 h-6 sm:w-7 sm:h-7 md:w-8 md:h-8 text-sanjaya-navy" />
              Support Center
            </h1>
            <p className="text-sm sm:text-base text-slate-600 mt-1">Raise a ticket — our team responds within 24–48 hours.</p>
          </div>
        </div>

        <SupportTicketsPage
          tokenKey="principal_token"
          role="principal"
          portalTitle="Principal Support"
          onBack={() => navigate('/principal/dashboard')}
          headerless={true}
        />
      </div>
    </ResponsiveLayout>
  );
}
